module.exports = __webpack_public_path__ + "img/decorator-mic.99512672.png";